const getFilterStrings = (queryStringValues) => {
    const filterStrings = {}

    Object.keys(queryStringValues).map(filterId => {
        let filterValues = queryStringValues[filterId]

        if(!Array.isArray(filterValues)) {
            filterValues = [filterValues]
        }

        const seperatorFirst = filterId + '='
        const seperatorSecond = '&' + seperatorFirst

        filterStrings[filterId] = seperatorFirst + filterValues.join(seperatorSecond)
    })

    return filterStrings
}

export default getFilterStrings